import { CONFIG } from '../config';
import BfvImage from '../BfvImage';
import resultTemplate from '../../../templates/partials/organisms/MD130_Torschuetzenliste/vue-result-template.hbs';
import loadMoreTemplate from '../../../templates/partials/organisms/MD130_Torschuetzenliste/vue-load-more-template.hbs';

class BfvScorer {
  constructor(options = {}) {
    const vue = {
      results: {
        template: resultTemplate,
        el: '#bfv-scorer__results',
      },
      loadMore: {
        template: loadMoreTemplate,
        el: '#bfv-scorer__load-more',
      },
    };

    this.$root = options.element;
    this.data = null;

    this.Vue = window.divae.Vue;
    this.resultComponentInitalData = {
      wrapperClass: this,
      results: [],
      loading: true,
      nextResults: null,
      scorerProfileTitle: 'Zum Spielerprofil',
    };
    this.apiRoute = this.$root.getAttribute('data-api-route');

    this.initVueComponents(vue);
  }

  init() {
    this.loadData();
  }

  /**
   * update the views after new data is loaded
   */
  dataLoaded() {
    this.vueResultComponent.updateData(this.data);
    this.vueLoadMoreComponent.updateData(this.data);
  }

  initVueComponents(vueOptions) {
    this.vueResultComponent = new this.Vue({
      el: vueOptions.results.el,
      template: vueOptions.results.template,
      data: Object.assign({}, this.resultComponentInitalData),
      props: [],
      methods: {
        loadMore() {
          this.wrapperClass.loadMore();
        },
        updateData(newData) {
          Object.assign(this.$data, this.wrapperClass.resultComponentInitalData, newData);
        },
      },
      updated() {
        this.$nextTick(() => {
          const resultArray = this.$refs.result;
          this.wrapperClass.loadImages(resultArray);
        });
      },
    });

    this.vueLoadMoreComponent = new this.Vue({
      el: vueOptions.loadMore.el,
      template: vueOptions.loadMore.template,
      data: Object.assign({}, this.resultComponentInitalData),
      props: [],
      methods: {
        loadMore() {
          this.wrapperClass.loadMore();
        },
        updateData(newData) {
          Object.assign(this.$data, this.wrapperClass.resultComponentInitalData, newData);
        },
      },
      updated() {
        this.$nextTick(() => {
          const resultArray = this.$refs.result;
          this.wrapperClass.loadImages(resultArray);
        });
      },
    });
  }

  /**
   * event happening on Button Click
   */
  loadMore() {
    this.loadData(this.data.nextResults);
  }

  /**
   * connect to Api and load the Data
   * @param loadNextResults
   */
  loadData(loadNextResults = '') {
    if (!this.apiRoute) {
      console.error('Please specify an API Route');
      return;
    }

    const getRouteWithParams = `${this.apiRoute}${loadNextResults}`;
    this.data = Object.assign({}, this.data, { loading: true });

    window.divae.restApi
      .loadData(getRouteWithParams)
      .then((_response) => {
        const response = _response;
        if (loadNextResults) {
          response.results = this.data.results.concat(response.results);
        }
        this.data = response;
        this.data.loading = false;
        this.dataLoaded();
      })
      .catch(() => {
        this.data.loading = false;
      });
  }

  /**
   * images don't get loaded automatically so we must do it manually
   * @param resultArray
   */
  loadImages(resultArray = []) {
    resultArray.forEach(($result) => {
      const $images = $result.querySelectorAll('.bfv-image__loader[data-module="BfvImage"]');
      Array.prototype.slice.call($images).forEach(($image) => {
        if (!$image.classList.contains('bfv-image--load-finished')) {
          const newImage = new BfvImage({ element: $image });
          newImage.disableAutoLoad = true;
          newImage.init();
        }

        const event = document.createEvent('event');
        event.initEvent(CONFIG.events.BFV_IMAGE_LOAD, false, true);
        $image.dispatchEvent(event);
      });
    });
  }
}

export default BfvScorer;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvScorer/index.js